import { render, staticRenderFns } from "./ManageAboutUs.vue?vue&type=template&id=6bb21e56&scoped=true&"
import script from "./ManageAboutUs.vue?vue&type=script&lang=js&"
export * from "./ManageAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./ManageAboutUs.vue?vue&type=style&index=0&id=6bb21e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb21e56",
  null
  
)

export default component.exports